export default __webpack_public_path__ + "static/media/crispsReadySalted.65c70c44.png";